import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/bg_login_reduce.jpg'


const _hoisted_1 = { class: "flex flex-col justify-start items-stretch flex-nowrap h-screen" }
const _hoisted_2 = { class: "flex-1 flex md:justify-around md:flex-row max-md:flex-col px-8 gap-8 md:flex-nowrap md:items-stretch bg-gray-100 overflow-y-auto py-10" }
const _hoisted_3 = { class: "md:flex-1 md:flex-grow-[2] flex flex-col items-stretch gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-full h-full object-cover rounded-xl shadow-sm max-h-40"
}, null, -1)
const _hoisted_5 = { class: "space-y-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-left font-bold text-black" }, "Atividades", -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row flex-wrap justify-start gap-3"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-row flex-wrap justify-start gap-16 items-center"
}
const _hoisted_9 = { class: "flex-1 flex flex-row items-center gap-4 max-w-full" }
const _hoisted_10 = { class: "flex-1 block space-y-1" }
const _hoisted_11 = { class: "overflow-hidden h-fit" }
const _hoisted_12 = { class: "h-[22rem] overflow-y-auto space-y-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "h-12 w-12 bg-blue-200 group-hover:bg-white text-primary rounded-full flex justify-center items-center" }
const _hoisted_15 = { class: "flex-1 flex flex-col items-start justify-evenly gap-3 py-2" }
const _hoisted_16 = { class: "text-left text-xs p-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "mem", -1)

import PartnerProviderStats from '@/components/dashboard/PartnerProviderStats.vue';
import StatQuery from '@/components/dashboard/StatQuery.vue';
import HeaderComponent from '@/components/HeaderComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import { CardHeader } from '@/components/ui/card';
import Card from '@/components/ui/card/Card.vue';
import CardContent from '@/components/ui/card/CardContent.vue';
import Skeleton from '@/components/ui/skeleton/Skeleton.vue';
import { PartnerProvider } from '@/http/partnerProvider';
import { GET_PARTNER_PROVIDERS, RETRIEVE_PARTNER_PROVIDERS } from '@/store';
import { set } from '@vueuse/core';
import { BookOpen, GraduationCap, LoaderCircle, Mailbox } from 'lucide-vue-next';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const { getters, dispatch } = useStore();

const partnerProviders = computed<PartnerProvider[]>(() => Object.values(getters[GET_PARTNER_PROVIDERS]));

const router = useRouter();

const didFindPartnerProviders = ref(false);
onMounted(async () => {
  set(didFindPartnerProviders, false);
  try {
    await dispatch(RETRIEVE_PARTNER_PROVIDERS);
  } catch (error) {
    set(didFindPartnerProviders, false);
  }
  setTimeout(() => set(didFindPartnerProviders, true), 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent, {
      class: "flex-1 flex-grow-0",
      title: "Dashboard"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (didFindPartnerProviders.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerProviders.value, (partnerProvider) => {
                  return (_openBlock(), _createBlock(PartnerProviderStats, {
                    "partner-provider": partnerProvider,
                    key: partnerProvider.id
                  }, null, 8, ["partner-provider"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(Card, { class: "cursor-pointer p-6 min-h-40 w-48 space-y-4 flex flex-col flex-nowrap items-stretch border-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(Skeleton, { class: "w-8 h-8" }),
                      _createVNode(Skeleton, { class: "w-full h-8" })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(StatQuery, {
                        stat: 'Em atendimento',
                        value: 0
                      }),
                      _createVNode(StatQuery, {
                        stat: 'Expiradas',
                        value: 0
                      }),
                      _createVNode(StatQuery, {
                        stat: 'Finalizadas',
                        value: 0
                      }),
                      _createVNode(StatQuery, {
                        stat: 'Total',
                        value: 0
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(LoaderCircle), { class: "w-8 h-8 animate-spin text-muted" })
              ]))
        ])
      ]),
      _createVNode(Card, { class: "md:flex-1 md:flex-grow p-4 flex flex-col" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(SectionComponent, { title: "Novidades" }, {
              icon: _withCtx(() => [
                _createVNode(_unref(Mailbox))
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                  {
                    title: 'Confira seus fluxos',
                    description: 'Agora é possível visualizar seus fluxos de mensagens. Seus leads vão ser atendidos automaticamente e solicitar o atendimento.',
                    action: async () => await _unref(router).push({ path: '/dashboard/automacoes' })
                  },
                  {
                    title: 'Atenda seus clientes',
                    description: 'Você consegue ver todos os clientes esperando por atendimento e atendê-los.',
                    action: async () => await _unref(router).push({ path: '/dashboard/atendimento' })
                  },
                  {
                    title: 'Cadastre seu WhatsApp',
                    description: 'Você pode informar credenciais de Token do Meta para a gente poder mandar mensagens para seus leads. É automático, você pode atender e fica na sua conta Meta!',
                    action: async () => await _unref(router).push({ path: '/dashboard/configuracoes' })
                  },
                ], (cardContent) => {
                    return (_openBlock(), _createBlock(Card, {
                      class: "overflow-y-auto",
                      key: cardContent.title
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CardContent, { class: "group py-2 pl-4 pr-2 hover:bg-blue-200" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              onClick: cardContent.action,
                              class: "flex flex-row flex-nowrap items-center justify-between gap-3"
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_unref(BookOpen))
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(CardHeader), { class: "p-0" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cardContent.title), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("p", _hoisted_16, _toDisplayString(cardContent.description), 1)
                              ])
                            ], 8, _hoisted_13)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            false
              ? (_openBlock(), _createBlock(SectionComponent, {
                  key: 0,
                  title: "Tutoriais"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(GraduationCap))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})